// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606041119/js/" + chunkId + "." + {"44":"e21f1282","225":"3ee69ee4","481":"69230733","486":"98a9f5a0","770":"5049f8f0"}[chunkId] + ".0.9338603189534498.chunk.js";
};